'use client';

import type { Ref } from 'react';

export interface PageTitleProps {
  title: string;
  description?: string;
  /** The step shell focuses this heading on every step (ADR-025). */
  headingRef?: Ref<HTMLHeadingElement>;
}

/** v8 page title: the step's single `<h1>` and an optional description. */
export function PageTitle({ title, description, headingRef }: PageTitleProps) {
  return (
    <div className="signup-page-title">
      <h1 ref={headingRef} tabIndex={-1} className="signup-page-title__heading">
        {title}
      </h1>
      {description ? <p className="signup-page-title__description">{description}</p> : null}
    </div>
  );
}
